import { httpFetch } from '@/renderer/utils/http';
import { getApiBase } from '@/renderer/utils/session';
const TOKEN_KEY = 'auth_token';
export function getStoredAuthToken() {
    try {
        return localStorage.getItem(TOKEN_KEY);
    }
    catch {
        return null;
    }
}
export function setStoredAuthToken(token) {
    try {
        if (!token)
            localStorage.removeItem(TOKEN_KEY);
        else
            localStorage.setItem(TOKEN_KEY, token);
    }
    catch { }
}
export async function registerUser(params) {
    const base = getApiBase();
    const res = await httpFetch(`${base}/api/users/register`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            email: params.email,
            password: params.password,
            display_name: params.display_name ?? null,
            avatar_url: params.avatar_url ?? null,
        }),
        timeoutMs: 15000,
    });
    const data = await res.json();
    if (!res.ok || !data?.success) {
        throw new Error(String(data?.error || `HTTP ${res.status}`));
    }
    const user = data.user;
    const token = data.token;
    return { user, token };
}
export async function loginUserWithEmail(email, password) {
    const base = getApiBase();
    try {
        const res = await httpFetch(`${base}/api/users/login`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email, password }),
            timeoutMs: 15000,
        });
        const data = await res.json();
        if (!res.ok || !data?.success) {
            let body = '';
            try {
                body = await res.text();
            }
            catch { }
            try {
                console.error('[auth] /api/users/login api error', { status: res.status, ok: res.ok, data, body: body ? body.slice(0, 500) : '' });
            }
            catch { }
            throw new Error(String(data?.error || `HTTP ${res.status}`));
        }
        return { user: data.user, token: String(data.token || '') };
    }
    catch (err) {
        try {
            console.error('[auth] /api/users/login thrown', { error: err?.message || String(err) });
        }
        catch { }
        throw err;
    }
}
export async function loginUserWithProvider(params) {
    const base = getApiBase();
    try {
        const res = await httpFetch(`${base}/api/users/login`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                provider: params.provider,
                provider_id: params.provider_id,
                email: params.email ?? null,
                display_name: params.display_name ?? null,
                avatar_url: params.avatar_url ?? null,
            }),
            timeoutMs: 20000,
        });
        const data = await res.json();
        if (!res.ok || !data?.success) {
            let body = '';
            try {
                body = await res.text();
            }
            catch { }
            try {
                console.error('[auth] /api/users/login api error', { status: res.status, ok: res.ok, data, body: body ? body.slice(0, 500) : '' });
            }
            catch { }
            throw new Error(String(data?.error || `HTTP ${res.status}`));
        }
        return { user: data.user, token: String(data.token || '') };
    }
    catch (err) {
        try {
            console.error('[auth] /api/users/login thrown', { error: err?.message || String(err) });
        }
        catch { }
        throw err;
    }
}
export async function getMyAccount(token) {
    const base = getApiBase();
    const tk = (token ?? getStoredAuthToken()) || '';
    if (!tk)
        throw new Error('missing_token');
    const res = await httpFetch(`${base}/api/users/me`, {
        method: 'GET',
        headers: { Authorization: `Bearer ${tk}` },
        timeoutMs: 10000,
    });
    const data = await res.json();
    if (!res.ok || !data?.success) {
        throw new Error(String(data?.error || `HTTP ${res.status}`));
    }
    return data.user;
}
export async function updateMyAccount(updates, token) {
    const base = getApiBase();
    const tk = (token ?? getStoredAuthToken()) || '';
    if (!tk)
        throw new Error('missing_token');
    const res = await httpFetch(`${base}/api/users/me`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${tk}` },
        body: JSON.stringify({ display_name: updates.display_name, avatar_url: updates.avatar_url }),
        timeoutMs: 15000,
    });
    const data = await res.json();
    if (!res.ok || !data?.success) {
        throw new Error(String(data?.error || `HTTP ${res.status}`));
    }
    return data.user;
}
export async function logoutAuth() {
    // Server-side session is JWT only; just clear token locally
    setStoredAuthToken(null);
}
export async function getCredits(token) {
    const base = getApiBase();
    const tk = (token ?? getStoredAuthToken()) || '';
    if (!tk)
        throw new Error('missing_token');
    const res = await httpFetch(`${base}/api/credits`, {
        method: 'GET',
        headers: { Authorization: `Bearer ${tk}` },
        timeoutMs: 10000,
    });
    const data = await res.json();
    if (!res.ok)
        throw new Error(`HTTP ${res.status}`);
    const diamonds = Number((data && (data.diamonds ?? data?.data?.diamonds)) || 0) || 0;
    return { diamonds };
}
